import { ReactNode } from 'react';

import { Link } from 'react-router-dom';

import { Icon } from '@/new/components/icon';
import { cn } from '@/new/lib/utils';

interface SubsetStatCardProps {
  value?: string | number;
  to?: string;
  children: ReactNode;
  onClick?: () => void;
}

export function SubsetStatCard({ value, to, children, onClick }: SubsetStatCardProps) {
  const content = (
    <div className="flex h-full flex-col justify-end">
      <p className="text-3xl font-semibold text-gray-700">
        {value ? value : <span className="font-light text-gray-400">-</span>}
      </p>

      <div className="mt-2 flex items-center justify-between gap-2 text-gray-600">
        <div className="flex items-center gap-2">{children}</div>

        <div className="flex items-center gap-2">
          {to && (
            <div className="flex items-center gap-1 text-xs font-medium text-blue-500">
              <span>View</span>
              <Icon className="lucide--arrow-right text-xs" />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return to ? (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        'min-w-fit grow rounded-md border border-l-3 border-gray-200 border-l-gray-200 bg-gradient-to-br from-white to-gray-50 px-4 py-3 transition-all duration-200',
        'cursor-pointer hover:shadow-lg/9 hover:shadow-teal-500',
      )}
    >
      {content}
    </Link>
  ) : (
    <div
      className={cn(
        'min-w-fit grow rounded-md border border-l-3 border-gray-200 border-l-gray-200 bg-gradient-to-br from-white to-gray-50 px-4 py-3 transition-all duration-200',
      )}
    >
      {content}
    </div>
  );
}
